import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import './displayListingPhoto.css';

interface Props {
  src?: string | null;
  name: string;
  priority?: boolean;
}

export default function DisplayListingPhoto({ src, name, priority = false }: Props) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  return (
    <div className="display-listing-photo">
      {src && failedSource !== src ? (
        <img
          src={src}
          alt={name}
          width={1200}
          height={900}
          loading={priority ? 'eager' : 'lazy'}
          fetchPriority={priority ? 'high' : 'auto'}
          decoding="async"
          onError={() => setFailedSource(src)}
        />
      ) : (
        <span className="display-listing-photo__missing">
          <ImageOff aria-hidden="true" />
          <span>Photo not available</span>
        </span>
      )}
    </div>
  );
}
